import React from 'react'

import HeaderLayout from 'components/Layout/Header'

import styles from './DeliveryPerformanceDetailHeader.module.css'

type Props = {
  warehouseName: string
  tenantName: string
}

export const DeliveryPerformanceDetailHeader: React.FC<Props> = ({ warehouseName, tenantName }) => {
  // HeaderLayout の右側は justify-content: space-between で children とユーザーメニューを両端に配置する。
  // 詳細画面は選択中の倉庫名 / テナント名をテキスト表示する（一覧のプルダウンと異なり選択不可）。
  return (
    <HeaderLayout>
      <div className={styles.names}>
        {warehouseName && <span className={styles.name}>{warehouseName}</span>}
        {tenantName && <span className={styles.name}>{tenantName}</span>}
      </div>
    </HeaderLayout>
  )
}
